import FolderChangeDigestRequest from 'owa-service/lib/contract/FolderChangeDigestRequest';
import GetFolderChangeDigestRequest from 'owa-service/lib/contract/GetFolderChangeDigestRequest';
import GetFolderChangeDigestResponse from 'owa-service/lib/contract/GetFolderChangeDigestResponse';
import getFolderChangeDigestOperation from 'owa-service/lib/operation/getFolderChangeDigestOperation';
import { getListViewTypeForFolder } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import folderId from 'owa-service/lib/factory/folderId';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import InboxViewType from 'owa-service/lib/contract/InboxViewType';
import getWatermarkForInboxClassificationFilter from '../selectors/getWatermarkForInboxClassificationFilter';
import InboxPlusPivotViewState from 'owa-mail-inbox-plus-store/lib/store/schema/InboxPlusPivotViewState';
import getHashtagsToInclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToInclude';
import getHashtagsToExclude from 'owa-mail-inbox-plus-store/lib/selectors/getHashtagsToExclude';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

// Max number of senders to return
const MAX_SENDERS_COUNT = 3;

/**
 * Action to get unseen data for a folder
 * @param pivotsToUpdate the pivots to get unseen data for
 * @return the GetFolderChangeDigestResponse
 */
export default function getInboxPlusFolderChangeDigestService(
    pivotsToUpdate: InboxPlusPivotViewState[]
): Promise<GetFolderChangeDigestResponse> {
    const folderChangeDigestFolders: FolderChangeDigestRequest[] = [];
    const inboxFolderId = folderNameToId('inbox');
    const folderIdForRequest = targetFolderId({ BaseFolderId: folderId({ Id: inboxFolderId }) });
    const isConversationView =
        getListViewTypeForFolder(inboxFolderId) == ReactListViewType.Conversation;

    for (const pivot of pivotsToUpdate) {
        const hashtagsToInclude = getHashtagsToInclude(pivot.InboxClassificationFilter);
        const hashtagsToExclude = getHashtagsToExclude(pivot.InboxClassificationFilter);

        const folderChangeDigest: FolderChangeDigestRequest = {
            FolderId: folderIdForRequest,
            IsConversationView: isConversationView,
            Watermark: getWatermarkForInboxClassificationFilter(pivot.InboxClassificationFilter),
        };

        if (pivot.InboxClassificationFilter === InboxClassificationFilter.Focused) {
            folderChangeDigest.ViewType = InboxViewType.FocusedView;
        } else if (pivot.InboxClassificationFilter === InboxClassificationFilter.Other) {
            folderChangeDigest.ViewType = InboxViewType.ClutterView;
        }

        if (hashtagsToInclude.length > 0) {
            folderChangeDigest.HashtagsToInclude = hashtagsToInclude;
        }

        if (hashtagsToExclude.length > 0) {
            folderChangeDigest.HashtagsToExclude = hashtagsToExclude;
        }
        folderChangeDigestFolders.push(folderChangeDigest);
    }

    const getFolderChangeDigestRequest: GetFolderChangeDigestRequest = {
        Folders: folderChangeDigestFolders,
        MaxSendersCount: MAX_SENDERS_COUNT,
    };

    return getFolderChangeDigestOperation(getFolderChangeDigestRequest).then(response => {
        return response;
    });
}
